/* eslint-disable */

var fileDownload = require('js-file-download');
import moment from "moment";
import jsPdf from "jspdf";
import { demoRandomArray } from "../data/demo";
import {
  getAssetProducing,
  getAssetConsuming,
  getCurrentUserAddress,
  fetchOffchainProducingAsset,
  getCurrentUser,
  getBarChartAssetsDataPerYear,
  getEnergyInTextWithUnit,
  getUserMatchingFrequency,
  getAuthenticatedUser,
  getOrganization
} from "../actions";

import { ACTION_TYPE } from "./ActionTypes";

import { enums } from "../enums/";
import { Decimal } from "decimal.js";
import { constants } from "../constants/index";

import { 
  timestampInSecondFromCertificateEndDateToMonthUTCYYYYMM
} from "../utils/date";

import { checkUserIsSuperAdminWithoutAuthentication } from "../utils/user/checkAdmin/CheckAdmin";
import * as requestHelper from "../utils/requestHelper"
import { convertCO2GramsToBestUnit } from "../utils/unitHelper";

export const sortCertificates = (certificates, order, orderBy) => dispatch => {
  dispatch({
    type: "SORT_CERTIFICATES",
    payload: { certificates, order, orderBy }
  });
};

export const getUserRelatedUtilityOrganization = () => async (dispatch) => {
  let currentUserDb = await getAuthenticatedUser();
  let utilityOrganization;
  if(currentUserDb.organization && currentUserDb.organization.type === enums.OrganizationTypes.UTILITY) {
    utilityOrganization = await getOrganization(currentUserDb.organization._id);
  }
  else if(currentUserDb.organization && currentUserDb.organization.type === enums.OrganizationTypes.CUSTOMER) {
    utilityOrganization = await getOrganization(currentUserDb.organization.parentOrganization);
  }
  dispatch({ type: 'SET_USER_RELATED_UTILITY_ORGANIZATION', payload: utilityOrganization });
}

export const changePage = page => dispatch => {
  dispatch({ type: "CHANGE_PAGE", payload: { page } });
};

export const changeRowsPerPage = rowsPerPage => dispatch => {
  dispatch({ type: "CHANGE_ROWS_PER_PAGE", payload: { rowsPerPage } });
};

const handleErrors = response => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
};

export const irecCountryChanged = (country) => dispatch => {
  dispatch({ type: "IREC_COUNTRY_CHANGED", payload: country });
};

export const irecYearChanged = (country) => dispatch => {
  dispatch({ type: "IREC_YEAR_CHANGED", payload: country });
};

export const irecAssetChanged = (country) => dispatch => {
  dispatch({ type: "IREC_ASSET_CHANGED", payload: country });
};

export const irecVolumeChanged = (country) => dispatch => {
  dispatch({ type: "IREC_VOLUME_CHANGED", payload: country });
};

export const irecCustomerOrganizationChanged = (customerOrganization) => dispatch => {
  dispatch({ type: "IREC_CUSTOMER_ORGANIZATION_CHANGED", payload: customerOrganization });
};

export const irecDatasetChanged = (file) => dispatch => {
  dispatch({ type: "IREC_DATASET_CHANGED", payload: file });
};

export const uploadIrecDataStart = (file, country, year, asset, volume, customerOrganization) => async dispatch => {
  dispatch({ type: 'UPLOAD_IREC_DATA_START' });
  if (file) {
    try{
      await uploadIrecData(file, country, year, asset, volume, customerOrganization);
      dispatch({ type: 'OPEN_SUCCESS', payload: 'IREC data uploaded !'});
    } catch(error) {
      dispatch({ type: 'OPEN_ERROR', payload: 'Could not upload irec data !' });
    }
    dispatch({ type: 'UPLOAD_IREC_DATA_ENDED'});
  } else {
    dispatch({ type: 'OPEN_ERROR', payload: 'No file provided' });
  }
}


export const uploadIrecData = async (file, country, year, asset, volume, customerOrganization) => {

  var formData = new FormData();
  formData.append("files", file);
  formData.append("country", country)
  formData.append("year", year)
  formData.append("asset", asset)
  formData.append("volume", volume)
  formData.append("customerOrganization", customerOrganization)


  const uploadedFileName = await fetch(
    process.env.REACT_APP_API_URL + "/api/irecs/upload", 
    {
      method: "POST",
      credentials: "include",
      body: formData
    }
  )
    .then(handleErrors)
    .then(function (response) {
      return response.json();
    })
    .then(function (body) {
      return body;
    });

  return uploadedFileName;
};

export const setMatchingDate = matchingDate => dispatch => {
  dispatch({ type: "SET_MATCHINGDATE_CERTIFICATES", payload: matchingDate });
};

export const toggleMatchingDateDialog = () => dispatch => {
  dispatch({ type: "TOGGLE_MATCHINGDATE_CERTIFICATES" });
};

export const toggleSecretWordDialog = () => dispatch => {
  dispatch({ type: "TOGGLE_SECRET_WORD_DIALOG_CERTIFICATES" });
};

export const toggleHourlyCertificatesDialog = () => dispatch => {
  dispatch({ type: "TOGGLE_HOURLY_CERTIFICATES_DIALOG" });
};

export const getHourlyCertificatesForDailyCertificate = (certificate) => async dispatch => {
  dispatch({type: "LOAD_HOURLY_CERTIFICATES_START"});
  let dailyCertificateAssociatedHourlyCertificates = certificate.hourlyConsumptionCertificates;
  if(dailyCertificateAssociatedHourlyCertificates && dailyCertificateAssociatedHourlyCertificates.length > 0) {
    dispatch({type: "LOAD_HOURLY_CERTIFICATES_SUCCESS", payload: dailyCertificateAssociatedHourlyCertificates});
  } else {
    dispatch({type: "LOAD_HOURLY_CERTIFICATES_FAIL"});
  }
}

export const getSecretWordForCertificate = (
  certificate
) => async dispatch => {
  dispatch({ type: "LOAD_SECRET_WORD_START" });

  const assetId = certificate._assetId;
  const consumptionAssetId = certificate._consumptionAssetId;
  const year = moment(certificate._creationTime).format("YYYY");
  const month = moment(certificate._creationTime).format("M");
  const day = moment(certificate._creationTime).format("D");

  const productionAsset = await fetchOffchainProducingAsset(assetId);

  const productionAssetName = productionAsset.name;

  let consumptionAsset;
  
  if (consumptionAssetId >= 0) {
    // -1 is for residual energy of a production asset.
    consumptionAsset = await getAssetConsuming(consumptionAssetId)
  }
  
  let consumptionAssetName = productionAsset.name; //By default, a certificate that is related to a production asset for residual energy (not matched)
  
  if (consumptionAsset) {
    consumptionAssetName = consumptionAsset.smireName;
  }

  const consumptionAssetSecretWordWithId = await fetch(
    process.env.REACT_APP_API_URL +
    "/api/secretwords/" +
    consumptionAssetId +
    "/" +
    year +
    "/" +
    month +
    "/" +
    day,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => {
      return res.json();
    })
    .then(result => {
      return result ? result.secret_word : null;
    })
    .catch(error => {
      console.error(error);
    });

  const consumptionAssetSecretWordWithName = await fetch(
    process.env.REACT_APP_API_URL +
    "/api/secretwords/?assetName=" +
    consumptionAssetName +
    "&year=" +
    year +
    "&month=" +
    month +
    "&day=" +
    day,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => {
      return res.json();
    })
    .then(result => {
      return result ? result.secret_word : null;
    })
    .catch(error => {
      console.error(error);
    });

  const productionAssetSecretWordWithId = await fetch(
    process.env.REACT_APP_API_URL +
    "/api/secretwords/" +
    assetId +
    "/" +
    year +
    "/" +
    month +
    "/" +
    day,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => {
      return res.json();
    })
    .then(result => {
      return result ? result.secret_word : null;
    })
    .catch(error => {
      console.error(error);
    });

  const productionAssetSecretWordWithName = await fetch(
    process.env.REACT_APP_API_URL +
    "/api/secretwords/?assetName=" +
    productionAssetName +
    "&year=" +
    year +
    "&month=" +
    month +
    "&day=" +
    day,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => {
      return res.json();
    })
    .then(result => {
      return result ? result.secret_word : null;
    })
    .catch(error => {
      console.error(error);
    });

  if (productionAssetSecretWordWithId && consumptionAssetSecretWordWithId) {
    dispatch({
      type: "LOAD_SECRET_WORD_SUCCESS",
      payload: {
        productionAssetSecretWord: productionAssetSecretWordWithId,
        consumptionAssetSecretWord: consumptionAssetSecretWordWithId
      }
    });
  } else if (
    productionAssetSecretWordWithName &&
    consumptionAssetSecretWordWithName
  ) {
    dispatch({
      type: "LOAD_SECRET_WORD_SUCCESS",
      payload: {
        productionAssetSecretWord: productionAssetSecretWordWithName,
        consumptionAssetSecretWord: consumptionAssetSecretWordWithName
      }
    });
  } else {
    dispatch({ type: "LOAD_SECRET_WORD_FAIL" });
  }
};

export const setProductionDate = productionDate => dispatch => {
  dispatch({
    type: "SET_PRODUCTION_DATE_CERTIFICATES",
    payload: productionDate
  });
};

export const toggleProductionDateDialog = () => dispatch => {
  dispatch({ type: "TOGGLE_PRODUCTION_DATE_CERTIFICATES" });
};

export const toggleWarningMatchingDialog = () => dispatch => {
  dispatch({ type: "TOGGLE_MATCHINGWARNING_CERTIFICATES" });
};

export const toggleGenerateMatchingCertificates = () => dispatch => {
  dispatch({ type: "TOGGLE_GENERATE_MATCHING_CERTIFICATES" });
};

export const toggleForceCertificatesGeneration = () => dispatch => {
  dispatch({ type: "TOGGLE_FORCE_CERTIFICATES_GENERATION" });
};

export const getCertificatesForDate = matchingDate => async dispatch => {
  dispatch({ type: "MATCHING_CHECK_CERTIFICATES_START" });

  const date = moment(matchingDate).format("YYYY-MM-DD");

  const userAddress = await getCurrentUserAddress();

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/certificates?_sender=" +
    userAddress +
    "&_owner=" +
    userAddress +
    "&_date=" +
    date,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => {
      return res.json();
    })
    .then(result => {
      dispatch({
        type: "MATCHING_CHECK_CERTIFICATES_SUCCESS",
        payload: result
      });
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: "MATCHING_CHECK_CERTIFICATES_FAIL" });
    });
};

export const matching = (
  matchingDate,
  generateCertificatesChecked,
  forceIfExistingCertificates
) => async dispatch => {
  dispatch({ type: "MATCHING_CERTIFICATES_START" });

  const date = moment(matchingDate).format("YYYY-MM-DD");
  const generateCertificates = generateCertificatesChecked;
  const nbRetry = 2;

  const data = {
    nbRetry,
    date,
    generateCertificates,
    forceIfExistingCertificates
  };
  const json = JSON.stringify(data);

  return await fetch(
    process.env.REACT_APP_API_URL + "/certificates-management/matching",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(async res => {
      return res.json();
    })
    .then(result => {
      dispatch({ type: "MATCHING_CERTIFICATES_SUCCESS" });
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: "MATCHING_CERTIFICATES_FAIL" });
    });
};

export const assetIdChanged = assetId => dispatch => {
  dispatch({ type: "ASSET_ID_CHANGED", payload: assetId });
};

export const ownerChanged = owner => dispatch => {
  dispatch({ type: "OWNER_CHANGED", payload: owner });
};

export const powerInWhChanged = certificatePowerInWh => dispatch => {
  dispatch({ type: "POWER_CHANGED", payload: certificatePowerInWh });
};

export const getCertificatesStart = () => async dispatch => {
  dispatch({ type: "GET_CERTIFICATES_START" });

  let frequency = await getUserMatchingFrequency()

  dispatch({
    type: ACTION_TYPE.DASHBOARD.SET_MATCHING_FREQUENCY,
    payload: frequency
  });

  return await fetch(
    `${process.env.REACT_APP_API_URL}/api/certificates/db`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => {
      return res.json();
    })
    .then(async certificates => {
      const user = getCurrentUser();
      const username = user.user_metadata.username;
      if (username === "demo") {
        certificates = certificates.map((certificate, i) => {
          const demoCertificate = {
            ...certificate,
            _powerInW: certificate._powerInW * demoRandomArray[i]
          };
          return demoCertificate;
        });
      }

      certificates.sort(function (a, b) {
        //sort by _productionDateEnd, desc
        return b._productionDateEnd - a._productionDateEnd;
      });

      getCertificatesSuccess(certificates, dispatch);
    })
    .catch(error => {
      console.error(error);
      getCertificatesFail(error, dispatch);
    });
};

export const getIrecsStart = () => async dispatch => {
  dispatch({ type: "GET_IRECTS_START" });

  await fetch(
    `${process.env.REACT_APP_API_URL}/api/irecs/`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => {
      return res.json();
    })
    .then(iRecs => {
      iRecs.sort(function (a, b) {
        return b.year - a.year;
      });

      getIrecsSuccess(iRecs, dispatch);
    })
    .catch(error => {
      console.error(error);
      getIrecsFail(error, dispatch);
    });
}

export const setLastCertificatesDataLoad = () => async dispatch => {
  dispatch({type: "SET_LAST_CERTIFICATES_DATA_LOAD"});
}

export const certificatesTypeChanged = (type) => async dispatch => {
  dispatch({ type: "GET_CERTIFICATES_START" });
  if(type === enums.CertificatesTypes.PRODUCTION.value) {
    dispatch({type: "FILTER_ON_PRODUCTION_CERTIFICATES"})
  } else if(type === enums.CertificatesTypes.CONSUMPTION.value) { 
    dispatch({type: "FILTER_ON_CONSUMPTION_CERTIFICATES"});
  } else if(type === enums.CertificatesTypes.IREC.value) {
    dispatch({type: "FILTER_ON_IRECS"});
  }
}

export const checkCertificate = file => async dispatch => {
  dispatch({ type: "CHECK_CERTIFICATE_START" });

  file = file[0];

  var formData = new FormData();
  formData.append("files", file);

  const res = await fetch(
    process.env.REACT_APP_API_URL + "/api/certificates-check",
    {
      method: "POST",
      credentials: "include",
      body: formData
    }
  )
    .then(async function (response) {
      const result = await response.json();
      return result;
    })
    .then(function (body) {
      return body;
    });

  if (res.result) {
    dispatch({
      type: "CHECK_CERTIFICATE_SUCCESS",
      payload: res.dataCertificate
    });
  } else {
    dispatch({ type: "CHECK_CERTIFICATE_FAIL" });
  }
};

export const resetCheckCertificate = () => async dispatch => {
  dispatch({ type: "RESET_CHECK_CERTIFICATE" });
};

export const downloadIrecFile = (fileName, customerOrganizationId) => async dispatch => {
  let data = await fetch(
    process.env.REACT_APP_API_URL + "/api/irecs/download/" + fileName + "/" + customerOrganizationId,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
  .then(handleErrors)
  .then(res => {return res.blob()})
  .catch(error => error);

  fileDownload(data, fileName);

};

export const getCertificatesSuccess = (certificates, dispatch) => {
  dispatch({type: "SET_ALL_CERTIFICATES", payload: certificates});
  
  let productionCertificates = certificates.filter(certificate => certificate._consumptionAssetId === -1)
  dispatch({type: "SET_PRODUCTION_CERTIFICATES", payload: productionCertificates});
  
  let consumptionCertificates = certificates.filter(certificate => certificate._consumptionAssetId >= 0)
  dispatch({type: "SET_CONSUMPTION_CERTIFICATES", payload: consumptionCertificates});

  dispatch({ type: "FILTER_ON_CONSUMPTION_CERTIFICATES"}); 
};

export const getIrecsSuccess = (iRecs, dispatch) => {
  dispatch({type: "SET_IRECS", payload: iRecs});
};

export const getCertificatesFail = (error, dispatch) => {
  dispatch({ type: "GET_CERTIFICATES_FAIL" });
};

export const getIrecsFail = (error, dispatch) => {
  dispatch({ type: "GET_IRECS_FAIL" });
};

export const getCertificateSuccess = (certificate, dispatch) => {
  dispatch({ type: "GET_CERTIFICATE_SUCCESS", payload: certificate });
};

export const getCertificateFail = (error, dispatch) => {
  dispatch({ type: "GET_CERTIFICATE_FAIL" });
};

export const getCertificate = async (certificateId, sender) => {
  const data = {
    _certificateId: certificateId,
    _sender: sender
  };
  const json = JSON.stringify(data);

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/certificates/" +
    certificateId +
    "?_sender=" +
    sender,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => error);
};

const onload2promise = obj => {
  return new Promise(resolve => {
    obj.onload = () => resolve(obj);
  });
};

const addImageProcess = async img => {
  await onload2promise(img);
};

export const generateCertificatePdf = (
  certificate,
  assetName,
  ownerName,
  owner,
  co2Saved,
  co2SavedUnit,
  t,
  i18n
) => async dispatch => {
  const assetProducing = await getAssetProducing(owner, certificate._assetId);

  let assetConsuming;
  if (certificate._consumptionAssetId == -1) assetConsuming = null;
  else
    assetConsuming = await getAssetConsuming(certificate._consumptionAssetId);

  let assetIconSrc = "./assets/images/icons/bolt.png?v=" + Date.now();

  switch (assetProducing.assetType) {
    case 0:
      assetIconSrc =
        "./assets/images/icons/icon-map-wind-turbine-cotton.png?v=" +
        Date.now();
      break;
    case 1:
      assetIconSrc =
        "./assets/images/icons/icon-map-solar-panel-cotton.png?v=" + Date.now();
      break;
    case 2:
      assetIconSrc =
        "./assets/images/icons/icon-map-dam-cotton.png?v=" + Date.now();
      break;
    case 5:
      assetIconSrc =
        "./assets/images/icons/geothermal.png?v=" + Date.now();
      break;
    case 6:
      assetIconSrc =
        "./assets/images/icons/solid-biomass.png?v=" + Date.now();
      break;
    default:
      assetIconSrc = "./assets/images/icons/bolt.png?v=" + Date.now();
  }

  let frequency = certificate.frequency

  let explorerUrl;
  switch (certificate._info) {
    case enums.SmartContractVersion.EWC:
    case enums.SmartContractVersion.V3:
      explorerUrl = enums.BlockchainExplorerUrl.EWC;
      break;
    case enums.SmartContractVersion.VOLTA:
      explorerUrl = enums.BlockchainExplorerUrl.VOLTA;
      break;
    default:
      explorerUrl = enums.BlockchainExplorerUrl.TOBALABA;
      break
  }

  let smartContractVersionName = certificate._info;
  
  let dateTimeFormat = 'YYYY-MM-DD HH:mm' //English date
  if(i18n.language === 'fr') {
    dateTimeFormat = 'DD-MM-YYYY HH:mm'
  } else if (i18n.language === 'en_us') {
    dateTimeFormat = 'MM-DD-YYYY h:mm a' //American date
  }

  //Images should be put in the /public folder
  const certificateTemplate = {
    title: t("Green Energy Certificate"),
    id: certificate._certificateId,
    iconSrc: "./assets/images/icons/contract.png?v=" + Date.now(),
    topLeftImage: "./assets/images/certificateImageTopLeft.png?v=" + Date.now(),
    bottomRightImage:
      "./assets/images/certificateImageBottomRight.png?v=" + Date.now(),
    quantity: {
      title: t("For the amount of"),
      iconSrc: "./assets/images/icons/bolt.png?v=" + Date.now(),
      value: parseInt(certificate._powerInW / 1000, 10).toLocaleString("en-US"),
      unit: "kWh",
      avoidedCo2: parseInt(co2Saved),
      avoidedCo2Unit: co2SavedUnit + " ",
      avoidedCo2Text: t("of CO2 avoided")
    },
    productionAsset: {
      title: t("Produced by the renewable asset"),
      id: assetProducing.id,
      name: assetName,
      immutableName: assetProducing.name,
      iconSrc: assetIconSrc,
      blockchainIconSrc: "./assets/images/icons/cube.png?v=" + Date.now(),
      address1: assetProducing.houseNumber + " " + assetProducing.street,
      address2: assetProducing.zip + " " + assetProducing.city,
      address3: assetProducing.country,
      latLong:
        assetProducing.gpsLatitude + "N, " + assetProducing.gpsLongitude + "E",
      blockchainAddress: constants.BlockchainOwnerAddress
    },
    date: {
      title: frequency === enums.FrequencyTypes.DAILY ? t("On the date (in UTC)") : t("For month of"),
      value: frequency === enums.FrequencyTypes.DAILY ? moment
        .unix(certificate._productionDateEnd)
        .utc()
        .format(dateTimeFormat) : timestampInSecondFromCertificateEndDateToMonthUTCYYYYMM(certificate._productionDateEnd, i18n),
      subtitle:
        t("Transferred on ") +
        moment.utc(certificate._creationTime).format(dateTimeFormat),
      iconSrc: "./assets/images/icons/calendar.png?v=" + Date.now(),
      blockchainAddress: "0x004A064a9AAf2fCD9687D82Fc5a1116e9325000B"
    },
    customer: {
      title: t("Used for the exclusive and sole account of"),
      value: certificate._ownerName,
      assetName: certificate._assetConsumptionName,
      immutableName: assetConsuming ? assetConsuming.smireName : " ",
      iconSrc: "./assets/images/icons/cube.png?v=" + Date.now(),
      blockchainIconSrc: "./assets/images/icons/cube.png?v=" + Date.now(),
      blockchainAddress: certificate._owner
    }
  };

  const certificateIcon = new Image();
  certificateIcon.src = certificateTemplate.iconSrc;
  await addImageProcess(certificateIcon);

  const certificateTopLeftImg = new Image();
  certificateTopLeftImg.src = certificateTemplate.topLeftImage;
  await addImageProcess(certificateTopLeftImg);

  const certificateBottomRightImg = new Image();
  certificateBottomRightImg.src = certificateTemplate.bottomRightImage;
  await addImageProcess(certificateBottomRightImg);

  const quantityIcon = new Image();
  quantityIcon.src = certificateTemplate.quantity.iconSrc;
  await addImageProcess(quantityIcon);

  const assetIcon = new Image();
  assetIcon.src = certificateTemplate.productionAsset.iconSrc;
  await addImageProcess(assetIcon);

  const blockchainIcon = new Image();
  blockchainIcon.src = certificateTemplate.productionAsset.blockchainIconSrc;
  await addImageProcess(blockchainIcon);

  const calendarIcon = new Image();
  calendarIcon.src = certificateTemplate.date.iconSrc;
  await addImageProcess(calendarIcon);

  const pdfDoc = new jsPdf({
    orientation: "landscape",
    unit: "cm",
    format: "a4"
  });

  //Set the background images
  pdfDoc.addImage(certificateTopLeftImg, "png", 0, 0, 10, 10);
  pdfDoc.addImage(
    certificateBottomRightImg,
    "png",
    pdfDoc.internal.pageSize.width - 10,
    pdfDoc.internal.pageSize.height - 10,
    10,
    10
  );

  //Display the title on top with a reward icon
  pdfDoc.addImage(
    certificateIcon,
    "png",
    pdfDoc.internal.pageSize.width / 2 - 0.75,
    2,
    1.5,
    1.5
  );
  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(24);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    certificateTemplate.title,
    pdfDoc.internal.pageSize.width / 2,
    5.2,
    "center"
  );

  //Display the quantity of renewable energy and a CO2 conversion
  pdfDoc.addImage(
    quantityIcon,
    "png",
    1.5,
    pdfDoc.internal.pageSize.height / 2 - 2.7,
    0.8,
    0.8
  );
  pdfDoc.setTextColor(200, 200, 200);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    certificateTemplate.quantity.title,
    2.5,
    pdfDoc.internal.pageSize.height / 2 - 3
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(20);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    certificateTemplate.quantity.value +
    " " +
    certificateTemplate.quantity.unit,
    2.5,
    pdfDoc.internal.pageSize.height / 2 - 2
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    certificateTemplate.quantity.avoidedCo2 +
    " " +
    certificateTemplate.quantity.avoidedCo2Unit +
    certificateTemplate.quantity.avoidedCo2Text,
    2.5,
    pdfDoc.internal.pageSize.height / 2 - 1.5
  );

  //Display the renewable asset details
  pdfDoc.addImage(
    assetIcon,
    "png",
    pdfDoc.internal.pageSize.width / 2 - 4.8,
    pdfDoc.internal.pageSize.height / 2 - 2.7,
    0.8,
    0.8
  );
  pdfDoc.setTextColor(200, 200, 200);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    certificateTemplate.productionAsset.title,
    pdfDoc.internal.pageSize.width / 2 - 3.5,
    pdfDoc.internal.pageSize.height / 2 - 3
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(20);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    certificateTemplate.productionAsset.name,
    pdfDoc.internal.pageSize.width / 2 - 3.5,
    pdfDoc.internal.pageSize.height / 2 - 2
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    t("Reference") + " : " + certificateTemplate.productionAsset.immutableName,
    pdfDoc.internal.pageSize.width / 2 - 3.5,
    pdfDoc.internal.pageSize.height / 2 - 1.5
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    certificateTemplate.productionAsset.address1.trim() === ""
      ? "_"
      : certificateTemplate.productionAsset.address1,
    pdfDoc.internal.pageSize.width / 2 - 3.5,
    pdfDoc.internal.pageSize.height / 2 - 1
  );
  pdfDoc.text(
    certificateTemplate.productionAsset.address2,
    pdfDoc.internal.pageSize.width / 2 - 3.5,
    pdfDoc.internal.pageSize.height / 2 - 0.5
  );
  pdfDoc.text(
    certificateTemplate.productionAsset.address3,
    pdfDoc.internal.pageSize.width / 2 - 3.5,
    pdfDoc.internal.pageSize.height / 2
  );
  pdfDoc.text(
    certificateTemplate.productionAsset.latLong,
    pdfDoc.internal.pageSize.width / 2 - 3.5,
    pdfDoc.internal.pageSize.height / 2 + 0.5
  );
  
  pdfDoc.addImage(
    blockchainIcon,
    "png",
    pdfDoc.internal.pageSize.width / 2 - 4.5,
    pdfDoc.internal.pageSize.height / 2 + 1,
    0.6,
    0.6
  );
  pdfDoc.text(
    certificate.owner ? certificate.owner : certificate.utilityOrganization.blockchainAddress,
    pdfDoc.internal.pageSize.width / 2 - 3.5,
    pdfDoc.internal.pageSize.height / 2 + 1.4
  );
  
  //Display the calendar informations
  pdfDoc.addImage(
    calendarIcon,
    "png",
    21.5,
    pdfDoc.internal.pageSize.height / 2 - 2.7,
    0.8,
    0.8
  );
  pdfDoc.setTextColor(200, 200, 200);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    certificateTemplate.date.title,
    22.5,
    pdfDoc.internal.pageSize.height / 2 - 3
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(20);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    certificateTemplate.date.value,
    22.5,
    pdfDoc.internal.pageSize.height / 2 - 2
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    certificateTemplate.date.subtitle,
    22.5,
    pdfDoc.internal.pageSize.height / 2 - 1.5
  );

  //Display the customer informations
  pdfDoc.setTextColor(200, 200, 200);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    certificateTemplate.customer.title,
    pdfDoc.internal.pageSize.width / 2,
    pdfDoc.internal.pageSize.height / 2 + 4,
    "center"
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(20);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    certificateTemplate.customer.value,
    pdfDoc.internal.pageSize.width / 2,
    pdfDoc.internal.pageSize.height / 2 + 5,
    "center"
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(16);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    certificateTemplate.customer.assetName,
    pdfDoc.internal.pageSize.width / 2,
    pdfDoc.internal.pageSize.height / 2 + 5.85,
    "center"
  );

  let referenceText = assetConsuming
    ? "Reference" + " : " + certificateTemplate.customer.immutableName
    : " ";

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(10);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    referenceText,
    pdfDoc.internal.pageSize.width / 2,
    pdfDoc.internal.pageSize.height / 2 + 6.5,
    "center"
  );

  //Display the footer informations
  pdfDoc.setFontSize(10);
  pdfDoc.setTextColor(200, 200, 200);
  pdfDoc.text(
    [
      t(
        "This information is publicly and unalterably available in the Blockchain : "
      ) + smartContractVersionName,
      t("and can be visible here "),
      `${explorerUrl}/tx/${certificate._txHash}`
    ],
    0.5,
    pdfDoc.internal.pageSize.height - 1.3
  );

  //Display the id of the assets and the certificate on the top right corner
  pdfDoc.setTextColor(256, 256, 256);
  pdfDoc.setFontSize(6);
  pdfDoc.text(
    certificateTemplate.id +
    "_" +
    certificate._assetId +
    "_" +
    certificate._consumptionAssetId,
    pdfDoc.internal.pageSize.width - 0.5,
    1.3,
    "right"
  );
  window.open(pdfDoc.output("bloburl"), "_blank");
  dispatch({ type: "CERTIFICATE_SAVED" });
};

export const generateYearlyCertificatePdf = (
  certificates, 
  year,
  t
) => async dispatch => {
  // First part : get the data to include in the PDF file
  const USER = getCurrentUser();

  let userIsSuperAdmin = checkUserIsSuperAdminWithoutAuthentication(USER);

  if(userIsSuperAdmin) {
    dispatch({ type: "OPEN_ERROR", payload: "YTD Certificate is not available for super admin." });
    return;
  }

  dispatch({ type: "CERTIFICATE_LOADING_PDF_START" });

  let barChartAssetsData = await getBarChartAssetsDataPerYear(year);

  let totalConsumption = 0;
  let totalConsumptionByAsset = [];
  let totalMatchedConsumptionByAsset = [];
  let yearlyTotalForCustomer = 0;

  let matchedConsumptionByAssetType = [
    {
      id: enums.AssetType.WIND_TURBINE,
      value: "Wind",
      production: 0
    },
    {
      id: enums.AssetType.SOLAR_PANEL,
      value: "Solar Panel",
      production: 0
    },
    {
      id: enums.AssetType.DAM,
      value: "Hydroelectric power",
      production: 0
    },
    {
      id: enums.AssetType.GEOTHERMAL,
      value: "Geothermal",
      production: 0
    },
    {
      id: enums.AssetType.SOLID_BIOMASS,
      value: "Solid Biomass",
      production: 0
    },
  ];

  // Retrieve the total consumption and the consumption for each asset
  for (let barChartDataItem of barChartAssetsData) {
    let totalMatchedConsumptionForCurrentAsset = 0;

    // Consumption assets
    let assetConsumptionDataArray = barChartDataItem.data.filter(assetData => assetData.assetType === enums.AssetType.CONSUMPTION);

    // For each consumption asset
    for (let assetConsumptionData of assetConsumptionDataArray) {
      let assetTotalConsumption = 0;

      for (let dailyConsumptionForAsset of assetConsumptionData.data) {
        totalConsumption += dailyConsumptionForAsset;
        assetTotalConsumption += dailyConsumptionForAsset;
      }

      totalConsumptionByAsset.push({
        assetName: assetConsumptionData.label,
        value: assetTotalConsumption * 1000
      })
    }

    // Production assets
    let assetProductionDataArray = barChartDataItem.data.filter(assetData => assetData.assetType !== enums.AssetType.CONSUMPTION);

    // For each production asset
    for (let assetProductionData of assetProductionDataArray) {
      let assetTotalProduction = 0;

      for (let dailyProductionForAsset of assetProductionData.data) {
        assetTotalProduction += dailyProductionForAsset;
      }

      let foundMatchedConsumptionByAssetTypeItem = matchedConsumptionByAssetType.find(
        matchedConsumptionByAssetTypeItem => matchedConsumptionByAssetTypeItem.id === assetProductionData.assetType
      )

      if (foundMatchedConsumptionByAssetTypeItem) {
        foundMatchedConsumptionByAssetTypeItem.production += assetTotalProduction;
      }
      totalMatchedConsumptionForCurrentAsset += assetTotalProduction;
    }

    totalMatchedConsumptionByAsset.push({
      assetName: assetConsumptionDataArray[0].label,
      value : totalMatchedConsumptionForCurrentAsset * 1000
    }) ;

    yearlyTotalForCustomer += totalMatchedConsumptionForCurrentAsset;
  }

  let filteredCertificates = certificates
    .filter(c => !c._retired)
    .filter(c => c._consumptionAssetId !== -1)
    .filter(c => moment.unix(c._productionDateEnd).format("YYYY") === year);

  let consumingAssetArray = [];

  for (let i = 0; i < filteredCertificates.length; i++) {
    //For each certificate, add it to the assets array if not already included
    let foundConsumingAsset = consumingAssetArray.find(consumingAsset => consumingAsset.id === filteredCertificates[i]._consumptionAssetId);

    if (!foundConsumingAsset) {
      consumingAssetArray.push({
        id: filteredCertificates[i]._consumptionAssetId,
        name: filteredCertificates[i]._assetConsumptionName,
        owner: filteredCertificates[i]._ownerName
      });
    }
  }

  const ownerName = certificates[0]._ownerName;

  let smartContractVersionName = certificates[0]._info;

  let consumption = getEnergyInTextWithUnit(totalConsumption * 1000);

  let totalEnergyMatched = getEnergyInTextWithUnit(yearlyTotalForCustomer * 1000);

  //to do: add geothermalEnergyMatched to PDF
  let windEnergyMatchedIn_kWh = new Decimal(matchedConsumptionByAssetType.find(item => item.id === enums.AssetType.WIND_TURBINE).production);
  let damEnergyMatchedIn_kWh = new Decimal(matchedConsumptionByAssetType.find(item => item.id === enums.AssetType.DAM).production);
  let solarEnergyMatchedIn_kWh = new Decimal(matchedConsumptionByAssetType.find(item => item.id === enums.AssetType.SOLAR_PANEL).production);
  let geothermalEnergyMatchedIn_kWh = new Decimal(matchedConsumptionByAssetType.find(item => item.id === enums.AssetType.GEOTHERMAL).production);
  let solidBiomassEnergyMatchedIn_kWh = new Decimal(matchedConsumptionByAssetType.find(item => item.id === enums.AssetType.SOLID_BIOMASS).production);
  let totalEnergyMatchedIn_kWh = new Decimal(yearlyTotalForCustomer);

  let windEnergyMatchedPercentage = windEnergyMatchedIn_kWh.dividedBy(totalEnergyMatchedIn_kWh).times(100).toNearest(0.1, Decimal.ROUND_HALF_UP);
  let damEnergyMatchedPercentage = damEnergyMatchedIn_kWh.dividedBy(totalEnergyMatchedIn_kWh).times(100).toNearest(0.1, Decimal.ROUND_HALF_UP);
  let solarEnergyMatchedPercentage = solarEnergyMatchedIn_kWh.dividedBy(totalEnergyMatchedIn_kWh).times(100).toNearest(0.1, Decimal.ROUND_HALF_UP);
  let geothermalEnergyMatchedPercentage = geothermalEnergyMatchedIn_kWh.dividedBy(totalEnergyMatchedIn_kWh).times(100).toNearest(0.1, Decimal.ROUND_HALF_UP);
  let solidBiomassEnergyMatchedPercentage = solidBiomassEnergyMatchedIn_kWh.dividedBy(totalEnergyMatchedIn_kWh).times(100).toNearest(0.1, Decimal.ROUND_HALF_UP);

  let windEnergyMatched = getEnergyInTextWithUnit(windEnergyMatchedIn_kWh.times(1000).toNumber());
  let damEnergyMatched = getEnergyInTextWithUnit(damEnergyMatchedIn_kWh.times(1000).toNumber());
  let solarEnergyMatched = getEnergyInTextWithUnit(solarEnergyMatchedIn_kWh.times(1000).toNumber());
  let geothermalEnergyMatched = getEnergyInTextWithUnit(geothermalEnergyMatchedIn_kWh.times(1000).toNumber());
  let solidBiomassEnergyMatched = getEnergyInTextWithUnit(solidBiomassEnergyMatchedIn_kWh.times(1000).toNumber());

  // Second  part : insert the data in designed PDF file
  const pdfDoc = new jsPdf({
    orientation: "landscape",
    unit: "cm",
    format: "a4"
  });

  const certificateIcon = new Image();
  certificateIcon.src = "./assets/images/icons/contract.png?v=" + Date.now();
  await addImageProcess(certificateIcon);

  const certificateTopLeftImg = new Image();
  certificateTopLeftImg.src =
    "./assets/images/certificateImageTopLeft.png?v=" + Date.now();
  await addImageProcess(certificateTopLeftImg);

  const certificateBottomRightImg = new Image();
  certificateBottomRightImg.src =
    "./assets/images/certificateImageBottomRight.png?v=" + Date.now();
  await addImageProcess(certificateBottomRightImg);

  const quantityIcon = new Image();
  quantityIcon.src = "./assets/images/icons/bolt.png?v=" + Date.now();
  await addImageProcess(quantityIcon);

  const calendarIcon = new Image();
  calendarIcon.src = "./assets/images/icons/calendar.png?v=" + Date.now();
  await addImageProcess(calendarIcon);

  //Set the background images
  pdfDoc.addImage(certificateTopLeftImg, "png", 0, 0, 10, 10);
  pdfDoc.addImage(
    certificateBottomRightImg,
    "png",
    pdfDoc.internal.pageSize.width - 10,
    pdfDoc.internal.pageSize.height - 10,
    10,
    10
  );

  let topOffset = 4;
  let leftOffset = 15;

  //Display the title on top with a reward icon
  pdfDoc.addImage(
    certificateIcon,
    "png",
    pdfDoc.internal.pageSize.width / 2 - 0.75,
    2,
    1.5,
    1.5
  );
  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(24);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    t("Green Energy Certificate"),
    pdfDoc.internal.pageSize.width / 2,
    5.2,
    "center"
  );

  let topOffsetTotal = topOffset + 2.4;

  //Display the total quantity of green electricity
  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(24);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    t("Total Green Energy"),
    pdfDoc.internal.pageSize.width / 2,
    topOffsetTotal + 0.8,
    "center"
  );

  pdfDoc.addImage(
    quantityIcon,
    "png",
    pdfDoc.internal.pageSize.width / 2 - 3,
    topOffsetTotal + 1,
    0.85,
    0.85
  );

  pdfDoc.text(
    totalEnergyMatched.value + " " + totalEnergyMatched.unit,
    pdfDoc.internal.pageSize.width / 2,
    topOffsetTotal + 1.8,
    "center"
  );

  pdfDoc.setTextColor(193, 197, 201);
  pdfDoc.setFontType("normal");
  pdfDoc.setFontSize(12);
  pdfDoc.text(
    t('out of') + " " + consumption.value + " " + consumption.unit + " " + t("consumed"),
    pdfDoc.internal.pageSize.width / 2,
    topOffsetTotal + 2.5,
    "center"
  );

  let topOffsetForRenewables = topOffsetTotal + 3.7;

  //Display the energy matched by type of technology
  let assetsTypeDataArray = [
    {
      label: t("From wind turbines"),
      src: "./assets/images/icons/icon-map-wind-turbine-cotton.png?v=" + Date.now(),
      energyMatched: windEnergyMatched,
      energyMatchedPercentage: windEnergyMatchedPercentage
    },
    {
      label: t("From hydroelectric power"),
      src: "./assets/images/icons/icon-map-dam-cotton.png?v=" + Date.now(),
      energyMatched: damEnergyMatched,
      energyMatchedPercentage: damEnergyMatchedPercentage
    },
    {
      label: t("From solar panels"),
      src: "./assets/images/icons/icon-map-solar-panel-cotton.png?v=" + Date.now(),
      energyMatched: solarEnergyMatched,
      energyMatchedPercentage: solarEnergyMatchedPercentage
    },
    {
      label: t("From geothermal"),
      src: "./assets/images/icons/geothermal.png?v=" + Date.now(),
      energyMatched: geothermalEnergyMatched,
      energyMatchedPercentage: geothermalEnergyMatchedPercentage
    },
    {
      label: t("From solid biomass"),
      src: "./assets/images/icons/solid-biomass.png?v=" + Date.now(),
      energyMatched: solidBiomassEnergyMatched,
      energyMatchedPercentage: solidBiomassEnergyMatchedPercentage
    }
  ]

  let assetsTypeDataArrayWithMatchedEnergy = assetsTypeDataArray.filter(assetTypeData => {
    console.log(assetTypeData)
    console.log('assetTypeData.energyMatched.value > 0', (assetTypeData.energyMatched.value > 0))
    return (assetTypeData.energyMatched.value > 0)
  })

  let numberOfTypeOfAssetsUsed = assetsTypeDataArrayWithMatchedEnergy.length
  let pageWidth = pdfDoc.internal.pageSize.width
  let assetsTypeBoxWidth = 4
  let marginLeftMinDistance = 2
  let marginLeftFinalDistance = marginLeftMinDistance

  let betweenAssetsTypeBoxCheckDistance = (pageWidth - (numberOfTypeOfAssetsUsed * assetsTypeBoxWidth))/(numberOfTypeOfAssetsUsed + 1)
  if(betweenAssetsTypeBoxCheckDistance >= marginLeftMinDistance) {
    marginLeftFinalDistance = betweenAssetsTypeBoxCheckDistance
  }

  let betweenAssetsTypeBoxFinalDistance = numberOfTypeOfAssetsUsed > 1 ? ( 
    pageWidth 
    - (numberOfTypeOfAssetsUsed * assetsTypeBoxWidth)
    - 2 * marginLeftFinalDistance
    )/(numberOfTypeOfAssetsUsed - 1)
    : 0;

  let cursorPosition = marginLeftFinalDistance;

  for (const assetsTypeData of assetsTypeDataArrayWithMatchedEnergy) { 
    const assetsTypeIcon = new Image();
    assetsTypeIcon.src = assetsTypeData.src;
    await addImageProcess(assetsTypeIcon);

    pdfDoc.addImage(
      assetsTypeIcon,
      "png",
      cursorPosition,
      topOffsetForRenewables,
      0.85,
      0.85
    );
  
    pdfDoc.setFontSize(12);
    pdfDoc.setTextColor(68, 88, 108);
    pdfDoc.setFontType("bold");
    pdfDoc.text(
      assetsTypeData.energyMatched.value + " " + assetsTypeData.energyMatched.unit,
      cursorPosition + 1.3,
      topOffsetForRenewables + 0.25
    );
  
    pdfDoc.setFontSize(10);
    pdfDoc.setTextColor(68, 88, 108);
    pdfDoc.setFontType("bold");
    pdfDoc.text(
      assetsTypeData.label,
      cursorPosition + 1.3,
      topOffsetForRenewables + 0.65
    );
  
    pdfDoc.setFontSize(8);
    pdfDoc.setTextColor(193, 197, 201);
    pdfDoc.setFontType("normal");
    pdfDoc.text(
      assetsTypeData.energyMatchedPercentage + "%",
      cursorPosition + 1.3,
      topOffsetForRenewables + 0.95
    );
  
    cursorPosition += assetsTypeBoxWidth + betweenAssetsTypeBoxFinalDistance; 

  }

  let topOffsetForYear = 0.8;

  //Display the year on the top right corner
  pdfDoc.addImage(
    calendarIcon,
    "png",
    pdfDoc.internal.pageSize.width - 3.5,
    topOffsetForYear,
    1,
    1
  );

  pdfDoc.setTextColor(66, 86, 107);
  pdfDoc.setFontSize(24);
  pdfDoc.text(year, pdfDoc.internal.pageSize.width - 0.5, topOffsetForYear + 0.8, "right");

  let assetBlocTopOffset = topOffsetForRenewables + 1.2;
  let assetBlocLeftOffset = 2;

  consumingAssetArray.map((currentConsumingAsset, idx) => {
    let currentAssetConsumption = totalConsumptionByAsset.find(c => {
      return c.assetName === currentConsumingAsset.name
    })

    let yearlyTotalForAsset = totalMatchedConsumptionByAsset.find(c => {
      return c.assetName === currentConsumingAsset.name
    })

    let yearlyTotalCo2ForAssetInGrams = 0;

    filteredCertificates
      .filter(c => {
        return c._consumptionAssetId === currentConsumingAsset.id;
      })
      .map(c => {
        yearlyTotalCo2ForAssetInGrams += 
        c.co2SavedInGrams ?
        c.co2SavedInGrams : 
        (c.co2SavedTemp ? 
          co2SavedTemp : 
          c._coSaved);
      });


    let [yearlyTotalCo2ForAssetInBestUnit, bestUnit] = convertCO2GramsToBestUnit(yearlyTotalCo2ForAssetInGrams, t, USER);
    let yearlyTotalCo2ForAssetInTons = (yearlyTotalCo2ForAssetInGrams / 1000000).toFixed(2);

    //x and y are both integers
    var remainder = idx % 4;

    if (remainder === 0) {
      //x is a multiple of y
      assetBlocTopOffset += 1.7;
      assetBlocLeftOffset = 2;
    } else {
      //x is not a multiple of y
      assetBlocLeftOffset += 7;
    }

    let assetTotalEnergyMatched = getEnergyInTextWithUnit(yearlyTotalForAsset.value);

    let assetTotalConsumption = getEnergyInTextWithUnit(currentAssetConsumption.value);

    pdfDoc.setFontSize(12);
    pdfDoc.setTextColor(68, 88, 108);
    pdfDoc.setFontType("bold");
    pdfDoc.text(currentConsumingAsset.name, assetBlocLeftOffset, assetBlocTopOffset);

    pdfDoc.setFontSize(10);
    pdfDoc.setTextColor(68, 88, 108);
    pdfDoc.setFontType("bold");
    pdfDoc.text(
      assetTotalEnergyMatched.value + " " + assetTotalEnergyMatched.unit + " " + t('out of') + " " + assetTotalConsumption.value + " " + assetTotalConsumption.unit,
      assetBlocLeftOffset,
      assetBlocTopOffset + 0.4
    );

    pdfDoc.setFontSize(8);
    pdfDoc.setTextColor(193, 197, 201);
    pdfDoc.setFontType("normal");
    let co2UnitLabel = parseInt(yearlyTotalCo2ForAssetInTons) >= 2 ? t("tons") : t("ton")
    pdfDoc.text(
      "(" + yearlyTotalCo2ForAssetInBestUnit + " " + bestUnit + " " + t("of CO2 avoided") + ")",
      assetBlocLeftOffset,
      assetBlocTopOffset + 0.8
    );
  });

  let ownerBlocTopOffset = assetBlocTopOffset + 2.5;

  pdfDoc.setFontSize(12);
  pdfDoc.setTextColor(193, 197, 201);
  pdfDoc.setFontType("normal");
  pdfDoc.text(
    t("Used for the exclusive and sole account of"),
    leftOffset,
    ownerBlocTopOffset,
    "center"
  );
  pdfDoc.setFontSize(24);
  pdfDoc.setTextColor(68, 88, 108);
  pdfDoc.setFontType("bold");
  pdfDoc.text(
    ownerName,
    leftOffset,
    ownerBlocTopOffset + 1,
    "center"
  );

  pdfDoc.setFontType("normal");
  pdfDoc.setFontSize(8);
  pdfDoc.setTextColor(200, 200, 200);
  pdfDoc.text(
    [
      t(
        "This information is publicly and unalterably available in the Blockchain : "
      ) + smartContractVersionName
    ],
    leftOffset,
    ownerBlocTopOffset + 2,
    "center"
  );

  pdfDoc.save("yearly_certificate_" + year + ".pdf");
  dispatch({ type: "CERTIFICATE_LOADING_PDF_SUCCESS" });
};

export const retireCertificate = (
  certificateId,
  owner,
  t,
  assetId
) => async dispatch => {
  dispatch({ type: "RETIRE_CERTIFICATE_START", payload: certificateId });

  //Get certificate utility organization from producing asset id
  const assetProducing = await getAssetProducing(owner, assetId);

  const CANCEL_COMMENT = "Empty comment, retired from frontend certificates list"

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/api/certificates/cancelCertificate?sender=" +
    assetProducing.organization.blockchainAddress +
    "&certificateId=" +
    certificateId +
    "&cancelComment=" +
    CANCEL_COMMENT,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
    .then(handleErrors)
    .then(async res => res.json())
    .then(async cancelledCertificatesIdsArray => {
      retireCertificateSuccess(cancelledCertificatesIdsArray, dispatch);
    })
    .catch(error => {
      console.error(error);
      retireCertificateFail(error, dispatch);
    });
};

export const retireCertificateSuccess = (cancelledCertificatesIdsArray, dispatch) => {
  dispatch({ type: "RETIRE_CERTIFICATE_SUCCESS", payload: cancelledCertificatesIdsArray });
};

export const retireCertificateFail = (error, dispatch) => {
  dispatch({ type: "RETIRE_CERTIFICATE_FAIL" });
};

export const transferCertificateStart = (
  certificate,
  newOwner
) => async dispatch => {
  dispatch({ type: "TRANSFERING_CERTIFICATE_START" });

  const data = {
    _newOwner: newOwner
  };
  const json = JSON.stringify(data);

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/certificates/" +
    certificate.id +
    "/owner?_sender=" +
    certificate.owner,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(async res => res.json())
    .then(async result => {
      certificate.owner = newOwner;
      transferCertificateSuccess(certificate, dispatch);
    })
    .catch(error => {
      console.error(error);
      transferCertificateFail(error, dispatch);
    });
};

export const transferCertificateSuccess = (certificate, dispatch) => {
  dispatch({ type: "TRANSFERING_CERTIFICATE_SUCCESS", payload: certificate });
  dispatch({ type: "OPEN_SUCCESS", payload: "Certificate transfered !" });
};

export const transferCertificateFail = (error, dispatch) => {
  dispatch({ type: "TRANSFERING_CERTIFICATE_FAIL" });
  dispatch({ type: "OPEN_ERROR", payload: error });
};

export const createCertificateStart = (
  certificate,
  history
) => async dispatch => {
  const user = getCurrentUser();
  const sender = user.app_metadata.address;

  dispatch({ type: "CREATE_CERTIFICATE_START" });

  if (isNaN(parseInt(certificate.assetId, 10))) {
    console.error("Error the asset id is not a number", certificate.assetId);
    createCertificateFail("Error the asset id is not a number", dispatch);
  } else if (isNaN(parseInt(certificate.powerInW, 10))) {
    console.error("The power is not a number", certificate.powerInW);
    createCertificateFail("The power is not a number", dispatch);
  } else {
    let certificateId = await createCertificate(
      certificate.assetId,
      certificate.powerInW,
      moment(certificate.productionDate)
        .add(2, "hours")
        .format("X"),
      sender
    ).catch(error => {
      console.error(error);
      createCertificateFail("Error creating certificate", dispatch);
    });
    certificateId = parseInt(certificateId, 10);

    if (isNaN(certificateId)) {
      console.error("certificateId is not a number", certificateId);
      createCertificateFail(
        "Error the certificateId is not a number",
        dispatch
      );
    } else {
      const completeCertificate = { ...certificate, id: certificateId };

      createCertificateSuccess(completeCertificate, history, dispatch);
    }
  }
};

export const createCertificate = async (
  assetId,
  powerInW,
  productionDate,
  sender
) => {
  const data = {
    _assetId: parseInt(assetId, 10),
    _powerInW: parseInt(powerInW, 10),
    _productionDate: parseInt(productionDate, 10) //timestamp like 1535673600
  };
  const json = JSON.stringify(data);

  return await fetch(
    process.env.REACT_APP_API_URL + "/certificates?_sender=" + sender,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data.logs[0].args._certificateId;
    })
    .catch(error => error);
};

export const createCertificateSuccess = (
  completeCertificate,
  history,
  dispatch
) => {
  dispatch({ type: "CREATE_CERTIFICATE_SUCCESS" });
  dispatch({ type: "OPEN_SUCCESS", payload: "New certificate created !" });
  history.push("/certificates");
  getCertificatesStart();
};

export const createCertificateFail = (error, dispatch) => {
  dispatch({ type: "CREATE_CERTIFICATE_FAIL" });
  dispatch({ type: "OPEN_ERROR", payload: error });
};

export const fetchSmireDataCertificates = async () => {
  let url =
    "https://smire.bluesafire.io/api/daily_data_from_date?site=plt_mareges,eget,fontanelles,lida_rte&day_count=30&specific_timezone=Europe%2FParis";
  let headers = new Headers();

  let username = "weechain.technical@gmail.com";
  let password = "oEltPRRZDErt6VtvJz7U1g==";

  headers.set(
    "Authorization",
    "Basic " + Buffer.from(username + ":" + password).toString("base64")
  );

  const response = await fetch(url, { method: "GET", headers: headers });

  const json = await response.json();

  return json;
};

export const getCertificatesData = async () => {
  const reqSiteTimeSeries = await fetchSmireDataCertificates();

  let barChartLabels = [];
  for (const curIndex of reqSiteTimeSeries.index) {
    barChartLabels.push(curIndex.substr(0, 10));
  }
  let barChartData = [
    { data: [], label: reqSiteTimeSeries.columns[0] },
    { data: [], label: reqSiteTimeSeries.columns[1] },
    { data: [], label: reqSiteTimeSeries.columns[2] },
    { data: [], label: reqSiteTimeSeries.columns[3], type: "line" }
  ];

  let totalMatchingProductionFontanelles = 0;
  let totalMatchingProductionEget = 0;
  let totalMatchingProductionMareges = 0;
  let totalResidualConsumption = 0;

  let certificates = [];
  let doughnutData = [];

  for (let i = 0; i < reqSiteTimeSeries.data.length; i++) {
    // MAREGES DATA
    barChartData[0].data.push(parseInt(reqSiteTimeSeries.data[i][0], 10));
    // EGET DATA
    barChartData[1].data.push(parseInt(reqSiteTimeSeries.data[i][1], 10));
    // FONTANELLES DATA
    barChartData[2].data.push(parseInt(reqSiteTimeSeries.data[i][2], 10));
    // LIDA DATA
    barChartData[3].data.push(parseInt(reqSiteTimeSeries.data[i][3], 10));

    //Let's build the matching data
    /*
      Priority 1 : Production Wind park W (kwh) Fontanelles
      Priority 2 : Production Hydro Site 1 H1 (kWh) Eget
      Priority 3 : Production Hydro Site 2 H2 (kwh) Marèges
      */

    let matchingProductionMareges = 0;
    let realProductionMareges = parseInt(reqSiteTimeSeries.data[i][0], 10);
    let matchingProductionEget = 0;
    let realProductionEget = parseInt(reqSiteTimeSeries.data[i][1], 10);
    let matchingProductionFontanelles = 0;
    let realProductionFontanelles = parseInt(reqSiteTimeSeries.data[i][2], 10);
    let residualConsumption = 0;
    let realConsumption = parseInt(reqSiteTimeSeries.data[i][3], 10);

    if (realProductionFontanelles < realConsumption) {
      residualConsumption = realConsumption - realProductionFontanelles;
      matchingProductionFontanelles = realProductionFontanelles;

      if (realProductionEget < residualConsumption) {
        residualConsumption = residualConsumption - realProductionEget;
        matchingProductionEget = realProductionEget;

        if (realProductionMareges < residualConsumption) {
          residualConsumption = residualConsumption - realProductionMareges;
          matchingProductionMareges = realProductionMareges;
        } else {
          matchingProductionMareges = residualConsumption;
          residualConsumption = 0;
        }
      } else {
        matchingProductionEget = residualConsumption;
        residualConsumption = 0;
      }
    } else {
      matchingProductionFontanelles = realConsumption;
      residualConsumption = 0;
    }

    doughnutData[i] = [
      matchingProductionFontanelles,
      matchingProductionEget,
      matchingProductionMareges,
      residualConsumption
    ];

    totalMatchingProductionFontanelles += matchingProductionFontanelles;
    totalMatchingProductionEget += matchingProductionEget;
    totalMatchingProductionMareges += matchingProductionMareges;
    totalResidualConsumption += residualConsumption;
  }

  let doughnutChartLabels = [
    "Hydro (Mareges)",
    "Hydro (Eget)",
    "Wind (Fontanelles)",
    "Not renewable"
  ];
  let doughnutChartData = [
    totalMatchingProductionMareges,
    totalMatchingProductionEget,
    totalMatchingProductionFontanelles,
    totalResidualConsumption
  ];
  let doughnutChartLastDayData = [
    doughnutData[doughnutData.length - 3][2],
    doughnutData[doughnutData.length - 3][1],
    doughnutData[doughnutData.length - 3][0],
    doughnutData[doughnutData.length - 3][3]
  ];

  let graphData = {
    doughnutChartLabels,
    doughnutChartData,
    doughnutChartLastDayData,
    doughnutData,
    barChartData,
    barChartLabels
  };
  return graphData;
};

const splitArray = array => {
  let returnArray = [];

  //this condition is too light
  if (array[0] == 0 && array[1] == 0) {
    returnArray.push(0);
    return returnArray;
  } else if (array[0] != 0) {
    returnArray.push(array[0]);
    let i;
    for (i = 1; i < array.length; i++) {
      if (array[i] != 0) {
        returnArray.push(array[i]);
      } else {
        return returnArray;
      }
    }
  } else {
    returnArray.push(array[0]);
    let i;
    for (i = 1; i < array.length; i++) {
      if (parseInt(array[i]) != 0) {
        returnArray.push(array[i]);
      } else {
        return returnArray;
      }
    }
  }
};

export const getCustomerOrganizationsWithIrecFeatureEnabled = () => async dispatch => {
  let url = `${process.env.REACT_APP_API_URL}/api/organizations/customer/irec-enabled`;
  let response = await requestHelper.getRequest(url);
  dispatch({type: "SET_CUSTOMER_ORGANIZATIONS_WITH_IREC_FEATURE_ENABLED", payload: response});
}

export const getNumberOfActiveOfficialCertificatesForDateRangeAndUtilityOrganization = async (startDate, endDate, utilityOrganization) => {
  let url = `${process.env.REACT_APP_API_URL}/api/certificates/db/count/active-official?startDate=${startDate}&endDate=${endDate}&organizationId=${utilityOrganization._id}`;
  
  let response = await requestHelper.getRequest(url);
 
  return response.numberOfActiveOfficialCertificates;
}

export const getNumberOfActiveOfficialDailyCertificatesForDateRangeAndUtilityOrganization = async (startDate, endDate, utilityOrganization) => {
  let url = `${process.env.REACT_APP_API_URL}/api/certificates/db/count/active-official-daily?startDate=${startDate}&endDate=${endDate}&organizationId=${utilityOrganization._id}`;
  
  let response = await requestHelper.getRequest(url);
 
  return response.numberOfActiveOfficialCertificates;
}



// WEBPACK FOOTER //
// ./src/actions/CertificatesActions.js